import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./normalize.css"; // link the css file with the index.html
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
